import * as React from "react";
import { SVGProps } from "react";

const OutlineArrowLeft = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="current"
    {...props}
  >
    <path d="M13.2599 16.28C13.0699 16.28 12.8799 16.21 12.7299 16.06L9.19992 12.53C8.90992 12.24 8.90992 11.76 9.19992 11.47L12.7299 7.94003C13.0199 7.65003 13.4999 7.65003 13.7899 7.94003C14.0799 8.23003 14.0799 8.71003 13.7899 9.00003L10.7899 12L13.7899 15C14.0799 15.29 14.0799 15.77 13.7899 16.06C13.6499 16.21 13.4599 16.28 13.2599 16.28Z" />
  </svg>
);
export default OutlineArrowLeft;
